"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Note_exports = {};
__export(Note_exports, {
  default: () => Note_default
});
module.exports = __toCommonJS(Note_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.59996 2.69912C8.59996 2.36775 8.33133 2.09912 7.99996 2.09912C7.66859 2.09912 7.39996 2.36775 7.39996 2.69912V3.39966H6.49999C5.06405 3.39966 3.89999 4.56372 3.89999 5.99966V19.5997C3.89999 21.0356 5.06405 22.1997 6.49999 22.1997H12C12.3314 22.1997 12.6 21.931 12.6 21.5997C12.6 21.2683 12.3314 20.9997 12 20.9997H6.49999C5.7268 20.9997 5.09999 20.3729 5.09999 19.5997V5.99966C5.09999 5.22646 5.7268 4.59966 6.49999 4.59966H7.39996V5.29912C7.39996 5.63049 7.66859 5.89912 7.99996 5.89912C8.33133 5.89912 8.59996 5.63049 8.59996 5.29912V4.59966H11.4V5.29912C11.4 5.63049 11.6686 5.89912 12 5.89912C12.3313 5.89912 12.6 5.63049 12.6 5.29912V4.59966H15.4V5.29912C15.4 5.63049 15.6686 5.89912 16 5.89912C16.3313 5.89912 16.6 5.63049 16.6 5.29912V4.59966H17.5C18.2732 4.59966 18.9 5.22646 18.9 5.99966V12.9999C18.9 13.3313 19.1686 13.5999 19.5 13.5999C19.8314 13.5999 20.1 13.3313 20.1 12.9999V5.99966C20.1 4.56372 18.9359 3.39966 17.5 3.39966H16.6V2.69912C16.6 2.36775 16.3313 2.09912 16 2.09912C15.6686 2.09912 15.4 2.36775 15.4 2.69912V3.39966H12.6V2.69912C12.6 2.36775 12.3313 2.09912 12 2.09912C11.6686 2.09912 11.4 2.36775 11.4 2.69912V3.39966H8.59996V2.69912Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.3875 14.7401C16.3875 14.4088 16.1189 14.1401 15.7875 14.1401C15.4562 14.1401 15.1875 14.4088 15.1875 14.7401V17.1381H12.7895C12.4581 17.1381 12.1895 17.4068 12.1895 17.7381C12.1895 18.0695 12.4581 18.3381 12.7895 18.3381H15.1875V20.7362C15.1875 21.0676 15.4562 21.3362 15.7875 21.3362C16.1189 21.3362 16.3875 21.0676 16.3875 20.7362V18.3381H18.7856C19.1169 18.3381 19.3856 18.0695 19.3856 17.7381C19.3856 17.4068 19.1169 17.1381 18.7856 17.1381H16.3875V14.7401Z",
      fill: "currentColor"
    }
  )
);
const SvgNote = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Note_default = SvgNote;
